package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.appCore.logic.pages.MerchantLocationDetailsViewModel
import com.example.mystybag.common.ui.views.BottomSheetUIView
import com.example.mystybag.common.views.CommonBottomSheetFactory

/**
 * Entry screen for location details/edit: shows loading while the location is fetched,
 * then navigates into the multi-step add-location flow (Step7 → … → Step9B) with data pre-filled.
 * User sees this only briefly before the first step of the flow.
 */
@Composable
fun MerchantLocationDetailsView(viewModel: MerchantLocationDetailsViewModel) {
    val uiState by viewModel.uiState.subscribeAsState()

    BottomSheetUIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        bottomSheetFactory = { CommonBottomSheetFactory(it) }
    ) {
        Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
            if (uiState.isLoading) {
                CircularProgressIndicator()
            }
        }
    }
}
